import { DefaultTypography, InputTestValueformat, ValTypography } from '../../utils/formatters'

export const TableDs = {
    id: 'calc_table',
    api: 'defBridge',
    title: 'calc_table',
    items: [{id:'showName', title: 'Наименование', formatter:DefaultTypography},
        {id:'refValue', title: 'Реальное значение', formatter:ValTypography},
        {id:'testValue', title: 'Тестовое значение', formatter:InputTestValueformat}],
  };
